/** Feature flag de build: muestra la feature "Junta de aclaraciones" (RFI). Off por default. */
export const JUNTA_ENABLED = import.meta.env.VITE_JUNTA_ENABLED === '1';

/** Feature flag de build: permite subir planos CAD (.dwg/.dxf). Off por default. */
export const DWG_DXF_ENABLED = import.meta.env.VITE_DWG_DXF_ENABLED === '1';

/**
 * Feature flag de build del PROTOTIPO staff-only "de la HP a la geometría"
 * (plano 2D + modelo 3D BIM + render desde la cotización). Off por default.
 * `Boolean('false')` es `true`, así que se acepta solo un puñado de valores
 * verdaderos (el placeholder del `.env.example` va vacío). El botón, además del
 * flag, exige staff Ecosoft; el portero real es el backend (flag + requireStaff).
 */
export const GEOMETRIA_HP_ENABLED = ['1', 'true', 'on', 'yes'].includes(
  String(import.meta.env.VITE_GEOMETRIA_HP_ENABLED ?? '').trim().toLowerCase(),
);

/**
 * Oculta, aun para staff Ecosoft, todo costo de IA en dinero (USD) de la interfaz. Sirve para
 * presentar desde la máquina de un staff sin enseñar lo que cuesta la IA. Off por default:
 * se enciende solo con `VITE_OCULTAR_COSTO_IA=1` en el `.env` local. No toca los tableros de
 * consumo del staff (`/staff/*`), cuyo propósito es justo ese costo.
 */
export const OCULTAR_COSTO_IA = import.meta.env.VITE_OCULTAR_COSTO_IA === '1';
